import { useRouteError, isRouteErrorResponse, Link } from 'react-router-dom'
import { Home, RefreshCw } from 'lucide-react'
import { Button } from '@/components/ui/button'

export const RootErrorBoundary = () => {
  const error = useRouteError()

  let statusCode: number | undefined
  let title: string
  let description: string

  if (isRouteErrorResponse(error)) {
    statusCode = error.status
    if (error.status === 404) {
      title = "We can't find that page"
      description = "The page you're looking for may have been moved or no longer exists. Let's get you back to shopping."
    } else if (error.status === 500) {
      title = 'Something went wrong'
      description = "We're having a hiccup on our end. Please try again in a moment."
    } else {
      title = 'Something went wrong'
      description = "We hit an unexpected bump. Don't worry — your data is safe."
    }
  } else {
    title = 'Something went wrong'
    description = "We hit an unexpected bump. Don't worry — your data is safe."
  }

  const handleRefresh = () => {
    window.location.reload()
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-warm-50 p-4 font-outfit">
      <div className="max-w-sm w-full text-center">
        {/* Status code or sad face */}
        <div className="mx-auto mb-6">
          {statusCode === 404 ? (
            <p className="text-8xl font-bold text-warm-200">404</p>
          ) : (
            <div className="w-24 h-24 mx-auto rounded-full bg-orange-50 flex items-center justify-center">
              <span className="text-5xl">:(</span>
            </div>
          )}
        </div>

        <h1 className="text-xl font-bold text-warm-900 mb-2">{title}</h1>
        <p className="text-sm text-warm-500 mb-8 leading-relaxed">{description}</p>

        <div className="flex flex-col gap-3">
          <Button
            onClick={handleRefresh}
            className="w-full rounded-xl bg-coral-500 hover:bg-coral-600 text-white font-semibold"
          >
            <RefreshCw className="mr-2 h-4 w-4" />
            Refresh Page
          </Button>
          <Button
            variant="outline"
            asChild
            className="w-full rounded-xl border-warm-200"
          >
            <Link to="/" className="inline-flex items-center">
              <Home className="mr-2 h-4 w-4" />
              Go Home
            </Link>
          </Button>
        </div>

        <p className="mt-6 text-xs text-warm-400">
          If this keeps happening, please{' '}
          <Link to="/contact" className="text-[#1a2d4d] hover:underline">
            contact support
          </Link>
        </p>
      </div>
    </div>
  )
}
